import { useState } from 'react';
import { Button, Form, FormControl, Modal } from 'react-bootstrap';

const FileEditModal = ({ file, showModal, setShowModal, handleEdit }) => {
	const [form, setForm] = useState({
		file: file?.name,
		humanName: file?.humanName,
		description: file?.description,
	});
	const [errors, setErrors] = useState({});

	const handleForm = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleModalEdit = () => {
		if (validateInputs()) {
			setForm({
				file: file?.name,
				humanName: '',
				description: '',
			});
		}
	};

	console.log({ file });

	const validateInputs = () => {
		let errors = {};
		if (!form.humanName) {
			errors.humanName = 'Give the file a human readable name.';
		}
		if (form.humanName && form.humanName.length < 5) {
			errors.humanName = 'At least 5 characters please.';
		}
		setErrors(errors);
		return Object.keys(errors).length === 0;
	};

	return (
		<Modal
			fullscreen="sm-down"
			show={showModal}
			onHide={() => setShowModal(false)}
		>
			<Modal.Header>
				<h4>File Details</h4>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group>
						<Form.Label>File:</Form.Label>{' '}
						<div className="d-inline">
							<strong>{file?.name || ''}</strong>
						</div>
					</Form.Group>
					<Form.Group>
						<Form.Label>Name:</Form.Label>
						<FormControl
							type="text"
							name="humanName"
							placeholder="Give your file a descriptive name."
							maxLength={50}
							isInvalid={errors.humanName}
							onChange={handleForm}
							value={form.humanName}
						/>
						{errors.humanName && (
							<div className="text-center">
								<Form.Text className="text-danger">
									{errors.humanName}
								</Form.Text>
							</div>
						)}
					</Form.Group>
					<Form.Group>
						<Form.Label>Notes:</Form.Label>
						<FormControl
							as="textarea"
							className="formControl"
							name="description"
							placeholder="Optional file notes."
							onChange={handleForm}
						>
							{form.description}
						</FormControl>
					</Form.Group>
					<div className="d-grid mt-4">
						<Button type="button" name="submit" onClick={handleModalEdit}>
							Save
						</Button>
					</div>
				</Form>
			</Modal.Body>
		</Modal>
	);
};
export default FileEditModal;
